export const resetPasswordStyles = {
  marginAuto: {
    margin: "auto",
  },
  formInput: {
    marginBottom: "16px",
  },
  resetHeading: {
    fontSize: "24px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "20px",
  },
  resetDescription: {
    fontSize: "16px",
    textAlign: "center",
    marginBottom: "24px",
  },
  centerFormButton: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "24px",
  },
  resetButton: {
    width: "100%",
    maxWidth: "400px",
  },

  logoContainer: {
    margin: "auto",
  },
  logoStyle: {
    display: "block",
    margin: "0 auto",
    maxWidth: "250px",
    marginBottom: "20px",
  },
  container1: {
    height: "calc(100dvh - 60px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    maxWidth: "600px",
    margin: "auto",
    paddingTop: "20px",
  },
  container2: {
    width: "80%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: "20px",
  }
};
